function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

document.addEventListener("DOMContentLoaded", () => {
  const handleMouseLeave = (event) => {
    const { clientX: mouseX, clientY: mouseY } = event;
    const { left, right, bottom } = event.target.getBoundingClientRect();
    const exitDirection =
      mouseX < left
        ? "left"
        : mouseX > right
        ? "right"
        : mouseY > bottom
        ? "down"
        : null;
    if (exitDirection) {
      const megaMenu = event.target.closest(".mega-menu");
      if (megaMenu) megaMenu.removeAttribute("open");
    }
  };
  document.querySelectorAll(".mega-menu__content").forEach((elm) => {
    elm.addEventListener("mouseleave", handleMouseLeave);
  });

  document.querySelectorAll(".header__menu-item").forEach((elm) => {
    elm.addEventListener("mouseenter", () => {
      document.querySelectorAll(".mega-menu[open]")?.forEach((openMenu) => {
        openMenu.removeAttribute("open");
      });
      const megaMenu = elm.closest(".mega-menu");
      if (megaMenu) megaMenu.setAttribute("open", "");
    });
  });
});

const CartTarget = document.getElementById("CartDrawer");
function refreshContent() {
  // var treashold = $("#exclusive-treashold").html();
  // var cartsubtotal = $("#cartsubtotal").html().replace(".00", "");

  // treashold = parseInt(treashold);
  // cartsubtotal = parseInt(cartsubtotal);

  // // console.log('treashold', treashold);
  // // console.log('cartsubtotal', cartsubtotal);

  // if (treashold > cartsubtotal) {
  //   let freePinDIv = CartTarget.querySelector("tr.free-pin");
  //   if (freePinDIv) {
  //     $.ajax({
  //       type: "POST",
  //       url: "/cart/change.js",
  //       dataType: "json",
  //       data: {
  //         quantity: 0,
  //         id: 48215952884022,
  //         sections: ["cart-drawer", "cart-icon-bubble"],
  //         sections_url: "/",
  //       }, // Set quantity to 0 to remove the item
  //       success: function () {
  //         freePinDIv.parentElement?.removeChild(freePinDIv);
  //         let cartItems = CartTarget.querySelector(".cart-items");
  //         let qtyInputs = cartItems.querySelectorAll("tr quantity-input input");
  //         if (qtyInputs) {
  //           for (let i = 0; i < qtyInputs.length; i++) {
  //             const item = qtyInputs[i];
  //             // console.log('item', item);
  //             item.dataset.index = i + 1;
  //           }
  //         }
  //       },
  //     });
  //   }
  // }
}

const debouncedRefreshContent = debounce(refreshContent, 200);
const observerOptions = { childList: true, attributes: true, subtree: true };
const observer = new MutationObserver(observerCallback);
function observerCallback(mutationsList) {
  mutationsList.forEach(function (node) {
    if (node) {
      // console.log('NODESS = ', node);
      if (
        node.target
          .closest("#CartDrawer")
          ?.querySelector(".drawer__cart-items-wrapper")
      ) {
        // console.log('Inside Node UP');
        observer.disconnect();
        debouncedRefreshContent();
        // refreshContent();
        observer.observe(CartTarget, observerOptions);
        // console.log('Inside Node Down');
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  refreshContent();
  observer.observe(CartTarget, observerOptions);
});

//========== subscriptionapp option text and price ===========
const subsBlockdocument = document.querySelectorAll(".shopify_subscriptions_fieldset");

if (subsBlockdocument.length > 0) {

  subsBlockdocument?.forEach(elm => {
    const inputPlan = elm.querySelectorAll('ul.shopify_subscriptions_app_block_label_children li input[type="radio"]');
    const subSaveLabel = elm.querySelectorAll(".shopify_subscriptions_purchase_option_wrapper label");
    let changetext = subSaveLabel[1];
    inputPlan.forEach(function (curInput, index) {
      curInput.addEventListener("click", (e) => {
        const savePrice = document.querySelector('.save_pri');
        savePrice.style.display = 'none';
        if (index === 0) {
          changetext.textContent = "Subscribe & Save - New Design Every Month!"; 
        } else {
          const month = index + 1;
          changetext.textContent = `Subscribe & Save - New Design Every ${month} Months!`;
        }
  
        //========= price js ===========
        setTimeout(() => {
          let option_pri = document.querySelector(".price--on-sale .price-item--sale");          
          let changePrice = elm.querySelector(".allocation_price");
          changePrice.textContent = option_pri.textContent;
        }, 400);
      });
    });
  })
  
}


document.addEventListener("DOMContentLoaded", () => {
  let selling_plan = document.querySelectorAll(
    '.cst_no_selling_plan [name="selling_plan"]'
  );
  // selling_plan = array.from(selling_plan);
  selling_plan.forEach((elm) => {
    elm.remove();
  });
});


//========== Custom cart popup ===========
document.addEventListener("DOMContentLoaded", function(){
  
  document.querySelectorAll(".cstm-cart-add-btn-pro").forEach((btn) => {
    btn.addEventListener("click", function() {
      const prd = document.createElement('div');
      prd.classList.add('cstm-add-popup', 'cstm-add-popup-open');
      prd.innerHTML = this.closest('li').querySelector('.cstm-add-popup').innerHTML;
      document.body.append(prd);

      prd.querySelector(".cstm-popup-close-btn")?.addEventListener('click', () => prd.remove());
      prd.querySelector(".popup-overlay")?.addEventListener('click', () => prd.remove());
    });
  });
  
});
//========== Custom cart popup ===========


//=================== Product block video js =======================
document.addEventListener("DOMContentLoaded", () => {
  const videoConn = document.querySelector('.cstm_video_blovk_conn');
  const popupConn = document.querySelector('.video_block_popup_conn');
  const popupVideo = popupConn?.querySelector('video');
  const popupSource = popupVideo?.querySelector('source');
  const body = document.body;

  // Open popup on video click
  videoConn?.querySelectorAll('.video_block_item video').forEach(video => {
    video.addEventListener("click", () => {
      const src = video.querySelector('source')?.getAttribute('src');
      if (src && popupConn && popupVideo && popupSource) {
        // window.scrollTo(0, 0);
        popupConn.classList.remove('hide_video_block_popup');
        popupSource.setAttribute('src', src);
        popupVideo.load();
        popupVideo.play();
        body.style.overflow = "hidden";
      }
    });
  });

  // Close popup and stop video
  popupConn?.querySelector('.video_block_popup_close')?.addEventListener("click", () => {
    popupConn.classList.add('hide_video_block_popup');
    popupVideo.pause();
    popupVideo.currentTime = 0;
    body.style.overflow = "visible";
  });
});


//=================== Product block video js =======================

